import { NavLink } from 'react-router-dom';

export type MenuItem = {
  key: string;
  icon: React.ReactNode;
  children: MenuItem[];
  label: string | React.ReactNode;
  type: string;
};

export const buildMenuItem = (
  label: string,
  key: string,
  url: string,
  icon?: React.ReactNode | null,
  children?: MenuItem[] | null,
  type?: string | null
): MenuItem => {
  return {
    // Use the base URL without query params as the key
    key: url ? url.split('?')[0] : key,
    icon,
    children,
    // Keep full URL with params for navigation
    label: url ? <NavLink to={url}>{label}</NavLink> : label,
    type,
  };
};
